import React, { FunctionComponent, Dispatch } from "react";
import { connect, ConnectedProps } from "react-redux";
import { logoutUser } from "../../redux/actions/AuthActions";
import { resetStates } from "../../redux/actions/ProfileActions";
import UserIcon from "./UserIcon";
import Button from "@material-ui/core/Button";
import WifiTwoToneIcon from "@material-ui/icons/WifiTwoTone";
import WifiOffIcon from "@material-ui/icons/WifiOff";
import { authActionInterface } from "../../redux/reducers/AuthReducers";
import { ProfileInterface } from "../../redux/reducers/ProfileReducers";
import { GameInterface } from "../../redux/reducers/GameReducers";

interface actionsType {
  logoutUser: () => (dispatch: Dispatch<authActionInterface>) => void;
  resetStates: () => (dispatch: any) => void;
}
interface RootState {
  profile: ProfileInterface;
  game: GameInterface;
}

const actionsReducers: actionsType = {
  logoutUser,
  resetStates
};

const mapStateToProps = (state: RootState) => ({
  profile: state.profile,
  game: state.game
});

const connector = connect(mapStateToProps, actionsReducers);

type PropsFromRedux = ConnectedProps<typeof connector>;

interface ProfileProps {}

const Profile: FunctionComponent<ProfileProps & PropsFromRedux> = props => {
  function renderContent() {
    if (props.profile.loading) {
      return (
        <div>
          <h4>Profile</h4>
          <div>Loading Info...</div>
        </div>
      );
    } else {
      return (
        <div>
          <h4>
            {props.profile.info ? props.profile.info.displayName : "Loading..."}
          </h4>
          <div
            style={{
              display: "flex",
              flexWrap: "wrap",
              margin: "20px 0 20px 0"
            }}
          >
            <div style={{ marginRight: "10px" }}>
              {props.profile.info ? (
                <UserIcon url={props.profile.info.userpic} />
              ) : (
                "Loading Icon.."
              )}
            </div>
            <div>
              {props.profile.info ? (
                <div>
                  @{props.profile.info.username}{" "}
                  {props.profile.info.isOnline ? (
                    <WifiTwoToneIcon color="secondary" />
                  ) : (
                    <WifiOffIcon color="error" />
                  )}
                </div>
              ) : (
                <div>Loading username...</div>
              )}
              {props.profile.info ? (
                <div>{props.profile.info.email}</div>
              ) : (
                <div>Loading email...</div>
              )}
            </div>
          </div>
          {props.profile.info ? (
            <div style={{ margin: "20px 0 20px 0" }}>
              Playing game: {props.game.playing ? "Yes" : "No"}
            </div>
          ) : (
            <div>Loading playing status...</div>
          )}
        </div>
      );
    }
  }
  return (
    <div>
      {renderContent()}
      <Button variant="outlined" onClick={props.logoutUser} color="inherit">
        Logout
      </Button>
    </div>
  );
};

export default connector(Profile);
